import { createSlice } from '@reduxjs/toolkit'

export interface PaymentModalState {
  open: boolean
}

const initialState: PaymentModalState = {
  open: false
}

export const paymentModalStateSlice = createSlice({
  name: 'paymentModalState',
  initialState,
  reducers: {
    openModal: (state) => {
      state.open = true;
    },
    closeModal: (state) => {
      state.open = false;
    }
  },
})

// Action creators are generated for each case reducer function
export const { openModal, closeModal } = paymentModalStateSlice.actions

export default paymentModalStateSlice.reducer